import TabItem from '@/components/tab-item/tab-item';
import { Box, Divider, Tabs, Text } from '@cmpsr/components';
import CompletedTestingPlans from '../completed-testing-plans/completed-testing-plans';
import YourTestingPlan from '../your-testing-plan/your-testing-plan.page';
import { useTestingPlanTabsController, TabLiteralsType } from './testing-plan-tabs.controller';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import Resources from '@/components/resources/resources';
import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';

type TabTypes = 'to-do' | 'completed';

const tabContent: TabLiteralsType = {
  'to-do': { name: 'To Do', component: <YourTestingPlan /> },
  completed: { name: 'Completed', component: <CompletedTestingPlans /> },
};
const tabKeys = Object.keys(tabContent).filter((key): key is TabTypes => key in tabContent);

export default function TestingPlanTabs() {
  const { isFitted, navBarSize, ref, isSticky, selectedTabIndex, getItemCount, handleTabChange } =
    useTestingPlanTabsController();

  return (
    <Tabs isLazy isFitted={isFitted} variant="line" w="full" index={selectedTabIndex} onChange={handleTabChange}>
      <DashboardLayout containerProps={{ pt: 0, pb: 0 }}>
        <Box ref={ref} pt={isSticky ? '50px' : 'inherit'} />
        <Box
          pt={{ base: 8, md: 10, lg: 12 }}
          {...(isSticky
            ? {
                position: 'fixed',
                top: `${navBarSize}px`,
                px: { base: 5, md: 8, lg: 16, xl: 24, xxl: 32 },
                left: 0,
                right: 0,
                width: '100%',
                zIndex: 1,
                bgColor: 'background-page',
                boxShadow: 'elevation-interactive',
                justifyContent: 'center',
              }
            : {
                position: 'unset',
              })}
        >
          <Tabs.List maxW="1184px" mx="auto" display="flex" justifyContent="flex-start">
            {tabKeys.map((tabKey) => (
              <TabItem
                key={tabKey}
                additionalProps={
                  // We want to left align the tabs and each tab should only take up as much width as its content
                  { width: 'auto', display: 'flex', justifyContent: 'flex-start', flex: 'none' }
                }
              >
                <Text variant="text-body-meta-medium" textTransform="uppercase" whiteSpace="nowrap">
                  {tabContent[tabKey].name} ({getItemCount(tabKey)})
                </Text>
              </TabItem>
            ))}
          </Tabs.List>
        </Box>
        <Divider />
        <DashboardGrid pt={{ base: 5, md: 8, lg: 12 }}>
          <Tabs.Panels>
            {tabKeys.map((tabKey) => (
              <Tabs.Panel key={tabKey} px={0} mb="spacer-10" pt="0">
                {tabContent[tabKey].component}
              </Tabs.Panel>
            ))}
          </Tabs.Panels>
          <Resources as="aside" width="full" />
        </DashboardGrid>
      </DashboardLayout>
    </Tabs>
  );
}
